// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import investigationWitnessEntity from './entities/investigation-witness.json';
import investigationWitnessMenu from '../pages/investigation-witness/menu.json';
import investigationWitnessFullForm from '../pages/investigation-witness/forms/full.json';
import investigationWitnessContextForm from '../pages/investigation-witness/forms/context.json';
import investigationWitnessMiniForm from '../pages/investigation-witness/forms/mini.json';
import investigationWitnessLookupForm from '../pages/investigation-witness/forms/lookup.json';
import investigationWitnessTableView from '../pages/investigation-witness/views/table.json';
import investigationWitnessCardsView from '../pages/investigation-witness/views/cards.json';
import investigationWitnessDashboardView from '../pages/investigation-witness/views/dashboard.json';

/** Тип запису «Свідок» зі сторінками пакета: меню, форми та подання з pages/investigation-witness/. */
export const investigationWitnessDefinition: IRecordTypeDefinition = {
  ...investigationWitnessEntity,
  views: assembleViewSet({
      table: investigationWitnessTableView,
      cards: investigationWitnessCardsView,
      dashboard: investigationWitnessDashboardView,
  }),
  form: investigationWitnessFullForm,
  forms: { full: investigationWitnessFullForm, context: investigationWitnessContextForm, mini: investigationWitnessMiniForm, lookup: investigationWitnessLookupForm },
  menu: investigationWitnessMenu,
} as IRecordTypeDefinition;
